/* eslint-disable consistent-return */
import '../../../../../../../../node_modules/@dicetechnology/doris-ui/src/scss/main.scss';
import '../../scss/doris-video-player.scss';
import React, {
    Fragment, useState
} from 'react';
import { PlayerInterface } from './player-interface';
import VideoCoverImage from './video-cover-image';
import { GRANTED, GRANTED_ON_SIGN_IN } from '../../../../general/js/api/endeavor/constants/api-constants';

const VideoPlayerWrapper = (
    {
        player,
        endeavorMetadata = { isEmpty: true },
        content,
        hideCover = false,
        playerKey,
        playerRef,
    },
) => {
    const [showVideo, setShowVideo] = useState(false || hideCover);

    const handlePlayerClick = () => {
        if (player !== null &&
            endeavorMetadata.accessLevel === GRANTED) {
            setShowVideo(true);
            player.play();
        }
    };

    const showCover = (!showVideo && !hideCover) || endeavorMetadata.accessLevel === GRANTED_ON_SIGN_IN;
    return (
        <Fragment>
            <div id={`player-wrapper-${content.videoId}`}
                className={endeavorMetadata.isEmpty ? 'hidden' : 'video-player-wrapper'}>
                <div className='container-player'>
                    {!endeavorMetadata.isEmpty && showCover && <VideoCoverImage
                        content={content}
                        videoMetadata={endeavorMetadata}
                        handleClick={handlePlayerClick}
                    />}
                    <div
                        id={playerKey}
                        className={!endeavorMetadata.isEmpty && showVideo ? 'dorisPlayer' : 'hidden'}
                        ref={playerRef}
                    >
                        {!endeavorMetadata.isEmpty && showVideo &&
                        <PlayerInterface player={player} />}
                    </div>
                </div>
            </div>
        </Fragment>

    );
};

export default VideoPlayerWrapper;
